import { cx } from "@emotion/css";

import { useTheme } from "@/modules/theme/hooks/useTheme";

import {
  InputErrorMessage,
  InputErrorMessageProps,
} from "../ErrorMessage/InputErrorMessage";
import { InputError } from "../InputError/InputError";

import { createRadioGroupStyles } from "./helpers/createRadioGroupStyles";

type RadioGroupProps = {
  label?: string;
  name: string;
  error?: string;
  className?: string;
  children: React.ReactNode;
} & InputErrorMessageProps;

export const RadioGroup: React.FC<RadioGroupProps> = ({
  className,
  label,
  name,
  error,
  errorMessages,
  children,
  ErrorMessage,
}) => {
  const classes = createRadioGroupStyles(useTheme());

  return (
    <div className={cx(classes.root, className)} role="radiogroup">
      <p className={classes.label}>{label}</p>
      {children}
      <InputError>
        <InputErrorMessage
          error={error}
          errorMessages={errorMessages}
          ErrorMessage={ErrorMessage}
          name={name}
        />
      </InputError>
    </div>
  );
};
